import { render } from "./ServiceResult.vue?vue&type=template&id=cefc33ae"
import script from "./ServiceResult.vue?vue&type=script&lang=js"
export * from "./ServiceResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__